import React from "react";
import { nanoid } from "@reduxjs/toolkit";

export const SESpeedometer = () => {
	const id = nanoid();

	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="14" cy="14" r="14" fill={`url(#paint_linear_speedometer_${id})`} />
			<g clipPath={`url(#clip_speedometer_${id})`}>
				<path
					d="M13.6157 8.5C12.1476 8.58427 10.7708 9.15477 9.67188 10.1342L11.3714 11.8337C12.011 11.3012 12.7876 10.9795 13.6157 10.9038V8.5Z"
					fill="#A8A8A8"
				/>
				<path
					d="M10.8358 12.3714L9.13625 10.6719C8.15602 11.7705 7.5848 13.1474 7.5 14.6159H9.90391C9.98008 13.7876 10.3025 13.0109 10.8358 12.3714Z"
					fill="#A8A8A8"
				/>
				<path
					d="M18.0959 14.6159H20.4998C20.415 13.1474 19.8438 11.7705 18.8636 10.6719L17.1641 12.3714C17.6973 13.0109 18.0198 13.7876 18.0959 14.6159Z"
					fill="#A8A8A8"
				/>
				<path
					d="M18.0993 15.3789C18.0459 15.9655 17.8785 16.4548 17.6805 16.8472C17.8736 17.1451 18.0347 17.3968 18.141 17.564C18.4307 18.0193 18.3666 18.6037 17.985 18.9853C17.8924 19.078 17.7866 19.1526 17.6719 19.2078L18.0677 19.6037C18.1422 19.6781 18.2398 19.7154 18.3375 19.7154C18.4351 19.7154 18.5327 19.6781 18.6072 19.6037C19.7479 18.4631 20.413 16.9749 20.504 15.3789H18.0993Z"
					fill="#A8A8A8"
				/>
				<path
					d="M9.90475 15.3789H7.5C7.59103 16.9749 8.25613 18.4631 9.39676 19.6037C9.47125 19.6782 9.56888 19.7154 9.66651 19.7154C9.76413 19.7154 9.86179 19.6781 9.93628 19.6037L11.0919 18.448C11.2408 18.299 11.2408 18.0575 11.0919 17.9085C10.7903 17.6069 10.0307 16.7626 9.90475 15.3789Z"
					fill="#A8A8A8"
				/>
				<path
					d="M18.3267 10.1342C17.2277 9.15475 15.8509 8.58427 14.3828 8.5V10.9038C15.2109 10.9795 15.9875 11.3012 16.6271 11.8337L18.3267 10.1342Z"
					fill="#A8A8A8"
				/>
				<path
					d="M14.8471 14.1585C14.3805 13.6919 13.6212 13.6919 13.1546 14.1585C12.688 14.6252 12.688 15.3844 13.1546 15.851C13.7441 16.4405 16.6411 18.2902 16.9695 18.4991C17.12 18.595 17.317 18.5733 17.4432 18.4471C17.5695 18.3209 17.5911 18.124 17.4952 17.9733C17.2863 17.645 15.4365 14.748 14.8471 14.1585Z"
					fill="#A8A8A8"
				/>
			</g>
			<defs>
				<linearGradient
					id={`paint_linear_speedometer_${id}`}
					x1="14"
					y1="0"
					x2="14"
					y2="28"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#C1C1C1" />
					<stop offset="0.0001" stopColor="#EDEDED" />
					<stop offset="1" stopColor="#EDEDED" stopOpacity="0" />
				</linearGradient>
				<clipPath id={`clip_speedometer_${id}`}>
					<rect width="14" height="14" fill="white" transform="translate(7 7)" />
				</clipPath>
			</defs>
		</svg>
	);
};
